import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlarmRuleConditionDto, AlarmRuleConditionType } from '../../../../../../types/dtos/alarm-rule-condition.dto';
import { AlarmRuleConditionFormDto } from '../../../../../../types/dtos/alarm-rule.dto';
import { BaseRule } from '../../base-rule';

export abstract class BaseRuleCondition extends BaseRule {
  abstract override getType(): AlarmRuleConditionType;

  abstract override formToConfig(form: AlarmRuleConditionFormDto): {};

  override createFormGroup(condition: Omit<AlarmRuleConditionDto, 'alarm_rule_id'>): FormGroup {
    const conditionForm = new FormGroup({
      id: new FormControl<number | null>(condition.id ?? null),
      type: new FormControl(condition.type, Validators.required),
      operator: new FormControl(condition.operator ?? 'AND', Validators.required),
      sortIndex: new FormControl<number>(condition.sort_index ?? 999),
      ...this.getFromControls(),
    });

    const config = {
      ...condition.config as {},
      ...(condition.overrideConfig ?? {}),
    };

    conditionForm.patchValue({
      ...this.configToFrom(config),
    }, {emitEvent: false});

    return conditionForm;
  }
}